import { render, staticRenderFns } from "./BadgeProfileImage.vue?vue&type=template&id=6d14c7b7&lang=pug&"
import script from "./BadgeProfileImage.vue?vue&type=script&lang=ts&"
export * from "./BadgeProfileImage.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeProfileImage.vue?vue&type=style&index=0&id=6d14c7b7&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports